import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../component/header';
import Footer from '../component/footer';

const Layout = () => {
    return (
        <>
            <Header />
            <main className="min-h-screen">
                <Outlet />
            </main>
            <Footer />
        </>
    );
};

export default Layout;
